module.exports = __webpack_public_path__ + "img/41.47fc8bb9.svg";